import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BreadcrumbService } from 'src/app/services';
import { AddressDetail, AddressType } from 'src/app/shared/models/address-detail';

@Component({
  selector: 'app-address-test',
  templateUrl: './address-test.component.html',
  styleUrls: ['./address-test.component.scss']
})
export class AddressTestComponent implements OnInit {
  address: AddressDetail;
  addressType: AddressType = AddressType.any;

  private _validating = false;
  public get validating(): boolean {
    return this._validating;
  }

  public set validating(val: boolean) {
    this._validating = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(private breadcrumbService: BreadcrumbService) {
    this.address = {} as AddressDetail;
  }

  ngOnInit(): void {
  }

  onButtonClick() {

  }

  isEstablishment(): boolean {
    return this.addressType === AddressType.establishment;
  }

  getAddress(place: google.maps.places.PlaceResult) {
    this.address = {} as AddressDetail;
    this.validating = true;
    if (place === undefined) {
      return;
    }

    if (this.addressType === AddressType.establishment) {
      this.address.name = place.name;
    }

    for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
      // @ts-ignore remove once typings fixed
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          this.address.addressLine1 = `${component.long_name} ${this.address.addressLine1 ?? ''}`;
          break;
        }

        case "route": {
          this.address.addressLine1 += component.short_name;
          break;
        }

        case "postal_code": {
          this.address.postCode = `${component.long_name}`;
          break;
        }

        case "locality":
          this.address.suburb = component.long_name;
          break;

        case "administrative_area_level_1": {
          this.address.state = component.short_name;
          break;
        }

        case "country":
          this.address.country = component.long_name;
          break;
      }
    }

    this.validating = false;
  }
}
